<!--
* @Name：报价信息对比明细详情
* @Author:王超
* @Date: 2021-12-02 16:13:46
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 16:13:46
-->
<template>
  <van-dialog
    class="attachment-dialog"
    :value="detailsVisible"
    title="授标结果"
    show-cancel-button
    cancel-button-text="关闭"
    cancel-button-color="#1989fa"
    :show-confirm-button="false"
    @cancel="close"
  >
    <div class="details-container">
      <hi-card v-for="(item, index) in bidSuppList" :key="item.quoteInfoPk" :row-index="index + 1">
        <van-row>
          <span>排名：</span>
          <span>第{{ index + 1 }}名</span>
        </van-row>
        <van-row>
          <span>投标方名称：</span>
          <span>{{ item.suppName }}</span>
        </van-row>
        <van-row>
          <span>中标含税单价：</span>
          <span>{{ item.awardPrice }}</span>
        </van-row>
        <van-row>
          <span>税率：</span>
          <span>{{ item.taxRate }}</span>
        </van-row>
        <van-row>
          <span>配额比例：</span>
          <span>{{ item.awardProportion }}</span>
        </van-row>
        <van-row>
          <span>中标数量：</span>
          <span>{{ item.awardQuantity }}</span>
        </van-row>
        <van-row v-if="item.taxRate && item.awardPrice">
          <span>剔税单价(元)：</span>
          <span>{{ (Number(item.awardPrice) / (1 + Number(item.taxRate) / 100)).toFixed(4) }}</span>
        </van-row>
      </hi-card>
    </div>
  </van-dialog>
</template>

<script>
export default {
  name: 'BidDetailInfo',
  comments: {
    'svg-icon': () => import('./TSvgIcon')
  },
  data() {
    return {}
  },
  props: {
    bidSuppList: {
      type: Array,
      default: () => []
    },
    detailsVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('close-details-dialog')
    }
  }
}
</script>
<style lang="scss" scoped>
.details-container {
  height: 500px;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 0 20px;
}
//.level_icon /deep/ .svg-icon {
//  width: 0.5rem;
//  height: 0.5rem;
//  position: absolute;
//  bottom: 25px;
//  right: 10px;
//}
</style>
